import { useCallback, useMemo, useState } from "react";
import { useListingLoader } from "../../../../../components/hooks/ListingHooks";
import dateColumn from "../../../../../layouts/Table/columns/dateColumn";
import numberColumn from "../../../../../layouts/Table/columns/numberColumn";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { getInvoices } from "../../../../../api/SubscriptionAPI";
import DownloadInvoice from "./DownloadInvoice";
import MainTable from "../../../../../layouts/Table/MainTable";
import { Flex, Text } from "@mantine/core";
import NoItemsModal from "../../../../../components/TableComponents/NoItemsModal";

const BillingTable = () => {
  const apiRef = useGridApiRef();
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const columns = useMemo(
    () => [
      numberColumn(),
      {
        field: "ident",
        headerName: lang.settings.invoice_name,
        width: 150,
      },
      {
        field: "totalAmount",
        type: "number",
        headerName: lang.settings.total_amount,
        width: 200,
      },
      {
        field: "totalAmountTaxesFree",
        type: "number",
        headerName: lang.settings.taxes_free,
        width: 200,
      },
      {
        field: "taxesAmountSum",
        type: "number",
        headerName: lang.settings.taxes,
        width: 200,
      },
      {
        field: "auxCode",
        headerName: lang.settings.invoice_code,
        width: 200,
      },
      dateColumn({
        field: "displayedDate",
        headerName: lang.emails_account.columns.last_use,
      }),
    ],
    []
  );
  const actionsCell = useCallback(({ row }) => {
    return <DownloadInvoice current={row} />;
  }, []);

  useListingLoader({
    loading,
    setLoading,
    listGetter: getInvoices,
    responseField: "invoices_list",
    setRows,
  });

  return (
    <Flex mih={500} pos={"relative"}>
      <NoItemsModal
        rows={rows}
        loading={loading}
        text={<Text size="xl"> {lang.settings.no_invoice} </Text>}
      />
      <MainTable
        apiRef={apiRef}
        columns={columns}
        rows={rows}
        loading={loading}
        setLoading={setLoading}
        actionsCell={actionsCell}
        actionsCellWidth={75}
        whiteButtons
        disableCheckboxes
        disableFilter
        disableGotoPage
        disablePerPage
        disableVisibleColumns
        tableSx={{
          "[data-field='ident']": {
            paddingLeft: 3,
          },
          ".table-toolbar": {
            zIndex: 500,
          },
        }}
      />
    </Flex>
  );
};

export default BillingTable;
